import CustomModal from 'components/global/CustomModal'
import React from 'react'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import CheckOutFromDevice from '../Common/CheckOutFromDevice'

const CheckoutFromDeviceModal = ({
  eventId,
  familyId,
  checkOutNotes,
  checkInId,
  participanType,
  participantId,
  pickUpPerson,
}) => {
  const {
    checkOutFromThisDeviceModalOpen,
    setCheckOutFromThisDeviceModalOpen,
  } = eventAttendanceStore(store => ({
    checkOutFromThisDeviceModalOpen: store.checkOutFromThisDeviceModalOpen,
    setCheckOutFromThisDeviceModalOpen:
      store.setCheckOutFromThisDeviceModalOpen,
  }))

  return (
    <>
      <CustomModal
        openModal={checkOutFromThisDeviceModalOpen}
        closeModal={setCheckOutFromThisDeviceModalOpen}
        title="Check-out from this device"
        width={1200}
        footer={false}
      >
        <CheckOutFromDevice
          eventId={eventId}
          familyId={familyId}
          checkOutNotes={checkOutNotes}
          checkInId={checkInId}
          participanType={participanType}
          participantId={participantId}
          pickUpPerson={pickUpPerson}
        />
      </CustomModal>
    </>
  )
}

export default CheckoutFromDeviceModal
